import { Alert } from "../../../components/alert/Alert";

export const CustomerBanner = ({
  title,
  message,
}: {
  title?: string;
  message?: string;
}) => {
  return (
    <Alert
      className={"w-full"}
      type={"information"}
      title={title ?? ""}
      message={message ?? ""}
    />
  );
};
